<template>
  <component :is="tag" v-if="isValidValue" :class="{ 'is-error': isError }">
    <template v-if="label">{{ label }}{{ labelSuffix }}</template><slot>{{ value }}</slot>{{ endSuffix }}
  </component>
</template>

<script setup>
const props = defineProps({
  value: {
    required: true,
  },
  label: {
    default: "",
  },
  labelSuffix: {
    default: "：",
  },
  endSuffix: {
    default: "；",
  },
  tag: {
    type: String,
    default: "span",
  },
  isError: {
    type: Boolean,
    default: false,
  },
});

const isValidValue = computed(() => {
  if (Array.isArray(props.value) || typeof props.value === "object") {
    return props.value && !!Object.keys(props.value).length;
  }

  return !["", null, undefined].includes(props.value);
});

function isValued(val) {
  return !["", null, undefined].includes(val);
}
</script>

<style lang="scss" scoped></style>
